<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('luckyDrawItem.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('luckyDrawItem.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>
            <img
              class="ts-rounded ts-h-6"
              v-lazy="{
                src: photo(record),
                error: require('@/assets/default-product_flat.jpg'),
                loading: require('@/assets/Rolling-1s-200px.svg'),
                preLoad: 1.3,
                attempt: 1
              }"
            />
          </td>
          <td>{{ record.item_name_kh }}</td>
          <td>{{ record.item_name_en }}</td>
          <td>{{ record.congratulation_text }}</td>
          <td class="ts-text-center">
            <span class="badge badge-success" v-if="record.is_popup_prize_box"
              >Yes</span
            >
            <span class="badge badge-danger" v-else>No</span>
          </td>
          <td class="ts-text-center">
            <span class="badge badge-success" v-if="record.is_rotation"
              >Yes</span
            >
            <span class="badge badge-danger" v-else>No</span>
          </td>
          <td class="ts-text-center">
            <a-switch
              :loading="loading"
              v-model="record.is_enable"
              size="small"
              @change="onIsEnableChange(record)"
            />
          </td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary mr-2"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a
              v-if="false"
              href="#"
              class="text-danger"
              v-tooltip="$t('delete')"
              @click="onDelete(record)"
              :disabled="record._deleting"
            >
              <i
                class="fas fa-circle-notch fa-spin"
                v-if="record._deleting"
              ></i>
              <Icon type="ios-trash" size="20" v-else />
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('luckyDrawItem.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
      >
        <from-action @cancel="clearEdit" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'companyIndex',
  components: {
    FromAction
  },
  data () {
    return {
      loading: false,
      showForm: false
    }
  },
  computed: {
    ...mapState('luckyDraw/luckyDrawItem', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.luckyDraw.luckyDrawItem.search
      },
      set (newValue) {
        this.$store.commit('luckyDraw/luckyDrawItem/SET_SEARCH', newValue)
        this.$store.commit('luckyDraw/luckyDrawItem/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        { name: this.$t('luckyDrawItem.photo'), style: 'width: 60px;' },
        { name: this.$t('luckyDrawItem.itemNameKh') },
        { name: this.$t('luckyDrawItem.itemNameEn') },
        { name: this.$t('luckyDrawItem.congratulationText') },
        {
          name: this.$t('luckyDrawItem.isPopupPrizeBox'),
          style: 'text-align: center;'
        },
        {
          name: this.$t('luckyDrawItem.isRotation'),
          style: 'text-align: center;'
        },
        {
          name: this.$t('luckyDrawItem.isEnable'),
          style: 'text-align: center;'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    photo (record) {
      if (record.photo) {
        return record.photo
      }
      return require('@/assets/default-product_flat.jpg')
    },
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('luckyDraw/luckyDrawItem/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew () {
      this.showForm = true
    },
    edit (record) {
      this.$store.commit('luckyDraw/luckyDrawItem/SET_EDIT_DATA', record)
      this.showForm = true
    },
    async onIsEnableChange (record) {
      this.loading = true
      this.$store
        .dispatch('luckyDraw/luckyDrawItem/changeIsEnable', {
          id: record.item_id,
          data: record
        })
        .then(response => {
          this.$toasted.success(response.message)
        })
        .catch(error => {
          record.is_enable = !record.is_enable
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async onDelete (record) {
      record._deleting = true
      this.$store
        .dispatch('luckyDraw/luckyDrawItem/destroy', record.item_id)
        .then(response => {
          this.fetchData()
          record._deleting = false
          this.notice({
            type: response.message_id == 0 ? 'success' : 'warning',
            text: response.message
          })
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
          record._deleting = false
        })
    },
    clearEdit () {
      this.$store.commit('luckyDraw/luckyDrawItem/SET_EDIT_DATA', {})
      this.showForm = false
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('luckyDraw/luckyDrawItem/RESET_STATE')
    next()
  }
}
</script>
